import React from "react";
import Icon from "@ant-design/icons";

const PhotoSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16 16V5.333C16 4 16 4 14.667 4H5.333C4 4 4 4 4 5.333v9.334C4 16 4 16 5.333 16m0 0H13m-7.667 0 1.834-1.833M16 12l-3.333-3.333L9 12.333m-.333-4.666a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        ></path>
    </svg>
);

const PhotoIcon = (props) => <Icon component={PhotoSvg} {...props} />;

export { PhotoIcon };